var BraintreeVisaCheckout = (function (braintree, $) {
    /* Initialize lite box function */

    var _parce_options = function (options, instance) {
        options = options || {};

        options.settings = options.settings || {}; 

        options.settings.shipping = {
            collectShipping: 'false'
        };

        var initOptions = instance.createInitOptions(options);

        return initOptions;
    }

    var _set_options = function (options, instance) {
        var initOptions = _parce_options(options, instance);

        $.each($('.v-button'), function () {
            this.reInit && this.reInit();
        });

        V.init(initOptions);
    };

    var _init_lite_box = function (options, instance, cb) {

        var _payload = new $.Deferred();

        var initOptions = _parce_options(options, instance);
        V.init(initOptions);

        V.on("payment.success", function (payment) {
            instance.tokenize(payment, function (tokenizeErr, payload) {
                if (!tokenizeErr) {
                    _payload.resolve(payload);
                    cb && cb(payload);
                }
            });
        });

		// NOTE: this promise will resolve only one time, so don't use them
        return _payload.promise();
    };

    var BraintreeVisaCheckout = function (opts) {
        this.$created = new $.Deferred();
        this.instance = null;
        this.currency = '';
        $.extend(this, opts);
    };

    $.extend(BraintreeVisaCheckout.prototype, {
        init: function (clientInstance) {
            var callback = $.proxy(this._callback, this, clientInstance);

            braintree.visaCheckout.create({ client: clientInstance }, callback);

            return this.$created.promise();
        },
        _callback: function (clientInstance, createErr, instance) {
            if (!createErr) this.instance = instance;
            this.$created.resolve(clientInstance);
        },
		initVisaLiteBox: function (amount, cb) {

            var options = this._parceOptions(amount);

            return this.$created.then($.proxy(function () {
                var xhr = _init_lite_box(amount && options || {}, this.instance, cb);
                return xhr;
		        }, this));

        },

        set_amount: function (amount) {
            this.$created.done($.proxy(function () {
                this._set_amount(amount);
            }, this));
        },

        _set_amount: function (amount) {
            var options = this._parceOptions(amount);
            this.instance && _set_options(options, this.instance);
        },

        _parceOptions: function (amount) {
			// NOTE: docs says it should be string
            amount = amount && amount.toString() || '';

            var options = {
                settings: {
                    review: { message: "", buttonAction: "Pay" },
                    shipping: { collectShipping: 'false' }
                },
                paymentRequest: {
                    currencyCode: this.currency,
                    total: amount
                }
            };

            return amount && options || {};
        }
    });

    return BraintreeVisaCheckout;
})(window.braintree, jQuery);